import {BaseEntity} from "./BaseEntity";

export class MapArea implements BaseEntity {
    constructor(
        public id?:number,
        public mapSiteID?:number,
        public floorLevel?:number,
        public name?:string,
        public pixelsPerMeter?:number,
        public imageWidth?:number,
        public imageHeight?:number,
        public geo1PixelsX?:number,
        public geo1PixelsY?:number,
        public geo1Latitude?:number,
        public geo1Longitude?:number,
        public geo2PixelsX?:number,
        public geo2PixelsY?:number,
        public geo2Latitude?:number,
        public geo2Longitude?:number,
        public fileDataID?:number){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.mapSiteID = json.mapSiteID;
        this.floorLevel = json.floorLevel;
        this.name = json.name;
        this.pixelsPerMeter = json.pixelsPerMeter;
        this.imageWidth = json.imageWidth;
        this.imageHeight = json.imageHeight;
        this.geo1Latitude = json.geo1Latitude;
        this.geo1Longitude = json.geo1Longitude;
        this.geo1PixelsX = json.geo1PixelsX;
        this.geo1PixelsY = json.geo1PixelsY;
        this.geo2PixelsX = json.geo2PixelsX;
        this.geo2PixelsY = json.geo2PixelsY;
        this.geo2Latitude = json.geo2Latitude;
        this.geo2Longitude = json.geo2Longitude;
        this.fileDataID = json.fileDataID;
    }
}
